import { Outlet } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { usePermissions, type PermissionsApi } from '../../shared/hooks/usePermissions';
import { Spinner } from '../../shared/ui/Spinner';
import { EmptyState } from '../../shared/ui/EmptyState';
import type { Permission } from '../../shared/types/permissions';

type Props =
  | { permission: Permission; check?: never }
  | { permission?: never; check: (api: PermissionsApi) => boolean };

export function RequirePermission(props: Props) {
  const api = usePermissions();

  if (!api.loaded) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <Spinner size="lg" label="Verificando permissões" />
      </div>
    );
  }

  const allowed = props.check
    ? props.check(api)
    : api.hasPermission(props.permission);

  if (!allowed) {
    return (
      <EmptyState
        icon={<ShieldOff size={48} />}
        title="Sem acesso"
        description="Você não tem permissão para acessar esta seção. Fale com o administrador se acredita que isso é um erro."
      />
    );
  }

  return <Outlet />;
}
